import React, { Component } from 'react'
import { Grid, Button, Icon, Modal, Message, Transition, Dimmer, Loader, Input } from 'semantic-ui-react'
import './SellerInfoModal.less'
import DGTextbox from 'components/FormControls/Textbox/DGTextbox';
import Formsy, { addValidationRule } from 'formsy-react';
import { format } from "react-phone-input-auto-format";
import { isNotBlankString, isValidCellNumber } from 'helpers/validation';
import DGTextarea from 'components/FormControls/Textarea/DGTextarea';
import { saveSellerInfo } from 'services/Seller';
import { formatPhone, unFormatPhone } from '../../helpers/parsePhone';


const initialState = {
    newAdditionalPhones: [],
    newSellerCellPhoneNo: '',
    newSellerWorkPhoneNo: '',
    selectedSellerID: 0,
    selectedSellerName: "",
    additionalInfo: '',
    showAPMessage: false,
    apMessage: '',
    apMessageSuccess: true,
    savingSellerInfo: false,
    serviceRadiusValue:""
};


addValidationRule('isNotBlankString', isNotBlankString);
addValidationRule('isValidCellNumber', isValidCellNumber);


class SellerInfoModal extends Component {

    constructor(props) {
        super(props);
        this.state = initialState;
    }

    componentDidMount() {
        this.setSellerData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.open && this.props.seller &&
            (prevProps.seller != this.props.seller || prevProps.open != this.props.open)) {
            this.setSellerData();
        }
    }

    setSellerData = () => {
        if (this.props.seller) {
            const seller = this.props.seller;

            const alternatePhonesFormatted = _.map(seller.alternatePhones, phone => {
                const unFormattedPhone = unFormatPhone(phone);
                const formattedPhone = format(unFormattedPhone);
                return formattedPhone;
            })
            const cellPhoneFormatted = seller.cellPhone ? format(unFormatPhone(seller.cellPhone)) : "";
            const workPhoneFormatted = seller.workPhone ? format(unFormatPhone(seller.workPhone)) : "";

            this.setState({
                selectedSellerID: seller.sellerID,
                newAdditionalPhones: alternatePhonesFormatted,
                additionalInfo: seller.additionalInfo,
                newSellerCellPhoneNo: cellPhoneFormatted,
                newSellerWorkPhoneNo: workPhoneFormatted,
                selectedSellerName: seller.name,
                serviceRadiusValue: seller.serviceRadius ? seller.serviceRadius  : ""
            });
        }
    }

    onValidSellerInfoSave = async (e, data) => {
        try {
            this.setState({ savingSellerInfo: true });
            const phones = this.state.newAdditionalPhones;
            const formattedPhones = _.map(phones, (phone) => {
                if (phone.length > 0) {
                    return formatPhone(phone);
                }
            })

            const bodyObject = {
                cellPhone: formatPhone(this.state.newSellerCellPhoneNo),
                workPhone: formatPhone(this.state.newSellerWorkPhoneNo),
                additionalInfo: this.state.additionalInfo,
                serviceRadius: parseInt(Math.abs(this.state.serviceRadiusValue))
            }
            
            const saveResponse = await saveSellerInfo(this.state.selectedSellerID, bodyObject, formattedPhones);

            if (saveResponse.resStatus == 200) {

                this.setState({ showAPMessage: true, apMessage: 'Information has been saved.', apMessageSuccess: true, savingSellerInfo: false });
                this.props.onSuccessfullSubmit();
            }
            else {
                this.setState({ showAPMessage: true, apMessage: 'Error saving this information.', apMessageSuccess: false, savingSellerInfo: false });
            }
        } catch (e) {
            console.log("Error in saving sellers details")
            console.log(e);
        }
    }

    sellerInfoModalClose = (e, data) => {
        this.setState({
            selectedSellerID: 0,
            newAdditionalPhones: [],
            additionalInfo: '',
            apMessageSuccess: false,
            apMessage: '',
            showAPMessage: false
        })
        this.props.onClose();
    }

    handleCellWorkPhoneChange = (value, fieldState) => {
        this.setState({ [fieldState]: format(value) })
    }

    handlePhoneChange = (value, index) => {
        const phones = this.state.newAdditionalPhones;
        phones[index] = format(value);
        this.setState({ newAdditionalPhones: phones }, () => {
        });
    }

    onPhoneKeyDown = (evt) => {
        if (evt.key != 'Backspace' && evt.key != 'Delete' && evt.key != 'Tab') {
            var patt = new RegExp(/^[0-9\b]+$/);
            var res = patt.test(evt.key);
            if (!res)
                evt.preventDefault()
        }
    }

    onRadiusKeyDown = (e) => {
        if (!((e.keyCode > 95 && e.keyCode < 106)
            || (e.keyCode > 47 && e.keyCode < 58)
            || e.keyCode == 8)) {
            e.preventDefault()
        }
    }

    onDeleteAdditonalPhone = (index) => {
        let phones = this.state.newAdditionalPhones;

        _.pullAt(phones, index);

        this.setState({ newAdditionalPhones: phones }, () => {
        });
    }

    onAddAlternatePhone = (e, data) => {
        const newPhones = this.state.newAdditionalPhones;
        newPhones.push('');
        this.setState({ newAdditionalPhones: newPhones }, () => {
        });
    }

    onAdditionalInfoChange = (e, data) => {
        this.setState({ additionalInfo: data.value });
    }

    handleRadiusChange = (value) => {
        this.setState({ serviceRadiusValue: parseInt(Math.abs(value)) });
    }

    render() {

        return (<>
            <Modal className="seller-info-modal-container"
                closeOnDimmerClick={false}
                closeOnEscape={false}
                onClose={this.sellerInfoModalClose}
                open={this.props.open}
                closeIcon>
                <Modal.Header>
                    {this.state.selectedSellerName}
                </Modal.Header>
                <Dimmer.Dimmable as={Modal.Content} blurring dimmed={this.state.savingSellerInfo}>
                    <Dimmer active={this.state.savingSellerInfo} inverted>
                        <Loader>Saving</Loader>
                    </Dimmer>
                    <Transition visible={this.state.showAPMessage} animation='fade' duration={500}>
                        <Message {...{
                            success: this.state.apMessageSuccess,
                            error: !this.state.apMessageSuccess
                        }}>
                            {this.state.apMessage}
                        </Message>
                    </Transition>

                    <Formsy onValidSubmit={this.onValidSellerInfoSave}>

                        <Grid className="grid-ap">
                            <Grid.Row>
                                <Grid.Column width={12}>
                                    <DGTextbox
                                        name={`cell-phone`}
                                        label="Cell Phone"
                                        value={this.state.newSellerCellPhoneNo}
                                        required
                                        onChange={(e, { value }) => this.handleCellWorkPhoneChange(value, "newSellerCellPhoneNo")}
                                        onKeyDown={this.onPhoneKeyDown}
                                        maxLength={14}
                                        validations={{
                                            isValidCellNumber: true,
                                        }}
                                        validationErrors={{
                                            isDefaultRequiredValue: 'This field is required',
                                            isValidCellNumber: 'Invalid Cell Number'
                                        }} />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                        <Grid className="grid-ap">
                            <Grid.Row>
                                <Grid.Column width={12}>
                                    <DGTextbox
                                        name={`work-phone`}
                                        label="Work Phone"
                                        value={this.state.newSellerWorkPhoneNo}
                                        required
                                        onChange={(e, { value }) => this.handleCellWorkPhoneChange(value, "newSellerWorkPhoneNo")}
                                        onKeyDown={this.onPhoneKeyDown}
                                        maxLength={14}
                                        validations={{
                                            isValidCellNumber: true,
                                        }}
                                        validationErrors={{
                                            isDefaultRequiredValue: 'This field is required',
                                            isValidCellNumber: 'Invalid Cell Number'
                                        }} />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>

                        <Grid className="grid-ap">
                            {
                                _.map(this.state.newAdditionalPhones, (phone, index) => {
                                    return <Grid.Row>
                                        <Grid.Column width={12}>
                                            <DGTextbox
                                                name={`ap${index}`}
                                                label="Additional Phone"
                                                value={phone}
                                                onChange={(e, { value }) => this.handlePhoneChange(value, index)}
                                                onKeyDown={this.onPhoneKeyDown}
                                                maxLength={14}

                                                validations={{
                                                    isValidCellNumber: true,

                                                }}
                                                validationErrors={{
                                                    isDefaultRequiredValue: 'This field is required',
                                                    isValidCellNumber: 'Invalid Cell Number'
                                                }} />
                                        </Grid.Column>
                                        <Grid.Column width={4} className="ap-delete-container">
                                            <Icon size="big" name='trash alternate outline'
                                                className="ap-delete" onClick={() => this.onDeleteAdditonalPhone(index)} />
                                        </Grid.Column>
                                    </Grid.Row>
                                })
                            }
                            {this.state.newAdditionalPhones.length < 3 && <Grid.Row>
                                <Grid.Column width={16}>
                                    <Button type="button" icon onClick={this.onAddAlternatePhone} className="ap-button-add-phone">
                                        <Icon name='plus' />
                                        Add Phone
                                    </Button>
                                </Grid.Column>
                            </Grid.Row>
                            }
                        </Grid>
                        <Grid className="grid-ap">
                            <Grid.Row>
                                <Grid.Column width={12}>
                                    <DGTextbox
                                        type={"number"}
                                        name={`radius`}
                                        label="Radius"
                                        value={this.state.serviceRadiusValue}
                                        required
                                        onChange={(e, { value }) => this.handleRadiusChange(value)}
                                        onKeyDown={this.onRadiusKeyDown}
                                        validations={{                                     
                                        }}
                                        validationErrors={{
                                            isDefaultRequiredValue: 'This field is required',
                                        }} />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                        <Grid>
                            <Grid.Row>
                                <Grid.Column width={16}>
                                    <DGTextarea
                                        name="additionalInfo"
                                        value={this.state.additionalInfo}
                                        maxLength={512}
                                        label="Additional Details"
                                        onChange={this.onAdditionalInfoChange} />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={16}>
                                    <button className="button-submit">Save</button>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Formsy>
                </Dimmer.Dimmable>
            </Modal>
        </>)
    }
}

export default SellerInfoModal